module.exports = __webpack_public_path__ + "static/img/ranking cursos 1680x1050.7881924.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/capacitador/populares/ranking cursos 1680x1050.jpg
// module id = aXyT
// module chunks = 47